export default function DarkFeatureSection() {
  return (
    <section id="features" className="w-full bg-foreground-950 py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-7xl mx-auto text-center">
        <p className="text-foreground-400 text-xs md:text-sm uppercase tracking-[0.2em] font-medium">
          Sourcing Intelligence
        </p>
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mt-4 leading-tight">
          Structured China Sourcing
          <br />
          For Modern Online Sellers
          <br />
          Scale in 2026
        </h2>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-12">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-white text-foreground-950 rounded-lg text-sm font-semibold hover:bg-white/90 transition-all whitespace-nowrap"
          >
            itaobuy sheet
            <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 border border-white/30 text-white rounded-lg text-sm font-semibold hover:bg-white/10 transition-all whitespace-nowrap"
          >
            buy it now
            <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 mt-16">
          {[
            {
              name: "Belts",
              url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
              imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20leather%20belt%20with%20brass%20buckle%20coiled%20on%20a%20dark%20charcoal%20surface%2C%20dramatic%20single%20spotlight%20lighting%2C%20luxury%20product%20photography%2C%20rich%20cognac%20brown%20against%20deep%20black%20background%2C%20sophisticated%20minimalist%20composition&width=300&height=240&seq=dark-belts-v2&orientation=landscape",
              isProduct: true,
            },
            {
              name: "Perfumes",
              url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
              imageUrl: "https://readdy.ai/api/search-image?query=Premium%20glass%20perfume%20bottle%20with%20warm%20amber%20liquid%20on%20a%20dark%20obsidian%20surface%2C%20soft%20golden%20backlight%20creating%20luminous%20glow%2C%20luxury%20fragrance%20photography%2C%20rich%20warm%20tones%20against%20deep%20black%2C%20elegant%20and%20mysterious%20aesthetic&width=300&height=240&seq=dark-perfumes-v2&orientation=landscape",
              isProduct: true,
            },
            {
              name: "Other Stuff",
              url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
              imageUrl: "https://readdy.ai/api/search-image?query=Eclectic%20collection%20of%20lifestyle%20products%20including%20a%20phone%20case%20keychain%20and%20small%20accessory%20items%20arranged%20on%20dark%20slate%20surface%2C%20soft%20overhead%20spotlight%2C%20contemporary%20product%20photography%2C%20clean%20contrast%20between%20objects%20and%20dark%20background&width=300&height=240&seq=dark-other-v2&orientation=landscape",
              isProduct: true,
            },
            {
              name: "Verified Suppliers",
              icon: "ri-shield-check-line",
              isProduct: false,
            },
            {
              name: "Trend Data",
              icon: "ri-line-chart-line",
              isProduct: false,
            },
          ].map((item, idx) => {
            if (item.isProduct && item.imageUrl) {
              return (
                <a
                  key={idx}
                  href={item.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block rounded-xl overflow-hidden bg-foreground-900 hover:bg-foreground-800 transition-colors cursor-pointer group"
                >
                  <div className="h-32 overflow-hidden">
                    <img
                      src={item.imageUrl}
                      alt={item.name}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-4 text-left">
                    <span className="text-white text-sm font-medium">{item.name}</span>
                  </div>
                </a>
              );
            }
            return (
              <div
                key={idx}
                className="bg-foreground-900 rounded-xl p-6 text-left hover:bg-foreground-800 transition-colors h-full"
              >
                <div className="w-10 h-10 rounded-lg bg-foreground-800 flex items-center justify-center mb-4">
                  <i className={`${item.icon} text-white/80 text-lg w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <span className="text-white text-sm font-medium">{item.name}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}